var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBscTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#4884E8",
    strokeWidth: 2,
    fill: "#FFF",
    cx: 20,
    cy: 20,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.52 20-2.261 2.259L10 20l2.259-2.259L14.519 20zM20 14.515l3.87 3.873 2.26-2.259L20 10l-6.13 6.13 2.26 2.258L20 14.515zm7.743 3.226L25.485 20l2.258 2.259L30 20l-2.257-2.259zM20 25.485l-3.87-3.871-2.26 2.257L20 30l6.13-6.13-2.26-2.256-3.87 3.87zm0-3.226L22.259 20 20 17.741 17.741 20 20 22.259z",
    fill: "#4884E8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBscTab);
export default __webpack_public_path__ + "static/media/bscTab.d9ca85d6.svg";
export { ForwardRef as ReactComponent };